
import {
    IndexTable,
    InlineStack,
    Box,
    Icon,
    Button,
    Thumbnail,
    Tooltip,
    Popover,
    Select,
    ActionList,
    Banner,
    Modal,
    Badge,
  } from "@shopify/polaris";
  import { ChevronDownIcon,NoteIcon ,PersonIcon,MenuHorizontalIcon,ChevronUpIcon} from "@shopify/polaris-icons";
  import React, { Fragment, useMemo, useState } from "react";
  import CustomerInformationModal from "../modal/CustomerInformationModal";
  import ShippingMethodsModal from "../modal/ShippingMethodsModal";
  import SymbolTake from "../../../../components/SymbolTake";
import _, { forEach } from "lodash";
import OrderTrackingModal from "../modal/OrderTrackingModal";
import RefundTipsModal from "../modal/RefundTipsModal";
import OrderInvoiceModal from "../modal/OrderInvoiceModal";
import BulkPaymentModal from "../modal/BulkPaymentModal";
import WalletForOrderModal from "../modal/WalletForOrderModal";
import PayForOrderModal from "../modal/PayForOrderModal";
import DlocalPayTipModal from "../modal/DlocalPayTipModal";
import PayoneerBalancesConnect from "../../../../components/PayoneerBalancesConnect";
import PayoneerBalancesOrderSelect from "../../../../components/PayoneerBalancesOrderSelect";
import PayoneerBalancesOrderConfirm from "../../../../components/PayoneerBalancesOrderConfirm";
import PayoneerBalancesAgain from "../../../../components/PayoneerBalancesAgain";
import InitNotPageContent from "../common/InitNotPageContent";
import CommonTableSkeletonItem from "../common/CommonTableSkeletonItem";
import { reqGetOrderNewPaymentProcess, reqGetOrderNewPaypalCheckout, reqPostOrderNewPaymentWallet } from "../../../../api";
import InitPageContent from "../common/InitPageContent";
import { useSelector } from "react-redux";
import ArchiveOrderModal from "../modal/ArchiveOrderModal";
  const OrderTable = ({
    selected,
    toastFun,
    loading,
    setSearchLoading,
    getPageData,
    requestParams,
    listData,
    setListData,
    selectableOrders,
    selectedResources,
    allResourcesSelected,
    handleSelectionChange,
    collapsibleItem,
    setCollapsibleItem
  }) => {
    const binding_sale = useSelector(
        (state) => state.languageReducer.subScriptData.binding_sale
      );
    // 总条数
            const pageMsg = () => {
              let total = listData.count ? listData.count : 0;
              const { page, size } = requestParams;
              const startNum = total > 0 ? (page - 1) * size + 1 : 0;
              const endNum = page * size > total ? total : page * size;
              let text = (
                <div>
                  Showing {startNum} - {endNum} of {total} results
                  <div  className="per_page_footer">
                    ,{" "}
                    at most{" "}
                    <div className="per_page_select">
                      {" "}
                      <Select
                        options={[
                          { label: 10, value: 10 },
                          { label: 20, value: 20 },
                          { label: 30, value: 30 },
                          { label: 50, value: 50 },
                        ]}
                        onChange={(value) => {
                          const calculatedTotalPages = Math.ceil(total / Number(value));
                          if (page > calculatedTotalPages) {
                             // 如果当前页码超出范围，重置为第一页
                            getPageData({ size: Number(value),page:1 });
                          }else {
                            getPageData({ size: Number(value) });
                          }
                          setSearchLoading(true);
                        }}
                        value={requestParams.size}
                      />
                    </div>
                    per page
                  </div>
                </div>
              );
              return text;
          
              // eslint-disable-next-line react-hooks/exhaustive-deps
            };
          
            // 是否存在上一页
            const hasPrevious = useMemo(() => {
              const { page, size } = requestParams;
              let total = listData.count ? listData.count : 0;
             
              const maxPageNum = _.ceil(total / size);
              if (page > 1 && page <= maxPageNum) {
                return loading ? false : true;
              } else if (page === 1) {
                return false;
              }
              // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [listData, requestParams, loading]);
          
            // 是否存在下一页
            const hasNext = useMemo(() => {
              const { page, size } = requestParams;
              let total = listData.count ? listData.count : 0;
              const maxPageNum = _.ceil(total / size);
              if (_.inRange(page, 1, maxPageNum)) {
                return loading ? false : true;
              } else if (page === maxPageNum) {
                return false;
              }
              // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [listData, requestParams, loading]);
          
            // 上一页
            const handlePrev = () => {
                getPageData({ page: Number(requestParams.page) - 1 });
                setSearchLoading(true);
              handleSelectionChange("page", false, 0);
              if (document) {
                if (document?.documentElement || document?.body) {
                  document.documentElement.scrollTop = document.body.scrollTop = 0;
                }
              }
            };
            // 下一页
            const handleNext = () => {
                getPageData({ page: Number(requestParams.page) + 1 });
                setSearchLoading(true);
              handleSelectionChange("page", false, 0);
              if (document) {
                if (document?.documentElement || document?.body) {
                  document.documentElement.scrollTop = document.body.scrollTop = 0;
                }
              }
            };
      // 物流方式弹窗
      const [shippingMethodsData,setShippingMethodsData] = useState({
        open:false
      })
      // 地址
      const [addressData,setAddressData] = useState({
        open:false
      })
       // 查询物流追踪记录
      const [trackingData,setTrackingData] = useState({
        open:false,
        id:'',
        data:{}
      })
      // 退款
      const [orderRefundData,setOrderRefundData] = useState({
        open:false,
        id:'',
        data:{}
      })
      // 开票
      const [invoicesData,setInvoicesData] = useState({
        open:false,
        id:'',
        data:{}
      })

      // 归档/解档
      // 归档/解档
  const [archiveOrderData, setArchiveOrderData] = useState({
    open: false,
    applyLoading: false,
    archive: true,
    ids: [],
    split_order_list:[]
  });


      // 订单支付
       //订单支付操作需要数据
  const [paymentData, setPaymentData] = useState({
    toPayOrderId: "",
    toPayOrderName: "",
    toPayOrderType: 0, // 订单类型：1 shopify 2 礼品包装 3 产品批发
    toPayActive: false,
    createPayPalOrderId: 0,
    toPayCouponId: 0,
    isPoints: false, //是否使用积分
    toPayCouponMoney: 0,
    isBatchToPay: false, //批量付款
    batchPayOrderIds: [],
    handleWalletActiveLoading: false, //钱包确定支付按钮
    toCheckoutLoading: false, //钱包支付加载状态
    payLogId: 0, // 执行支付记录ID
    operationNumber: 0,
    currentExecutionsNumber: 0,
    noFreeShippingTipsActive: false, //不包邮订单提示物流选择
    noFreeShippingOrder: "",
    // 提示订单地址异常不能付款
    addressFailedModal: false,
    addressFailedOrder: "",
    setOrderStatusIds: [], // 更改订单地址异常状态
    addressFailedLoading: false,
    isShowBulkPaymentModal: false, //批量支付弹窗
    totalPrice: 0, //价格钱包支付计算产品总价
    totalShippingCost: 0, //运费钱包支付计算产品总价
    isNotSourcing: false, //订单sku未sourcing完成弹窗
    user_cpf:'',//巴西税号
    is_br:0
  });

  const handleBulkPayment = (id)=>{
    // 创建 Set 用于快速查找
    const idSet = new Set(id);
    // 过滤出 id 在 Set 中的对象
    const result = listData?.list.filter(item => idSet.has(item.id)).map(item=>item.dsm_record);
    let data = listData?.list;

    let ids = [];
    let name = [];

    // (type=1) shopify订单，不包邮的需要提示选择物流方式
    let isPass = true;
    let noFreeShippingOrderName = [];
    let allAddressTrue = true;
    let orderAddressFailedNames = [];

    //金额
    var totalPrice = 0;
    let totalShippingCost = 0;
    // let itemsCount = 0;
    let notSourcing = false;
    for (let i = 0; i < data.length; i++) {
      if (result.includes(data[i].dsm_record)) {
        if (
          data[i].dsm_payment_status === "Unpaid" ||
          data[i].dsm_payment_status === "Partially paid"
        ) {
          ids.push(data[i].dsm_record);
          name.push(data[i].dsm_order_number);
          totalPrice +=
            Number(data[i].product_cost) + parseFloat(data[i].ioss_vat);

          // 如果存在未sourcing完成sku的则提示弹窗
          // if (
          //   data[i].order_detail.no_source.length > 0 ||
          //   data[i].order_detail.pending.length > 0
          // ) {
          //   notSourcing = true;
          // }

          // 订单地址检测
          if (data[i].address_failed === 1) {
            allAddressTrue = false;
            orderAddressFailedNames.push(data[i].dsm_order_number);
          }

          // (shopify订单 type=1 \ 自定义订单 type=4) 不是包邮，且没有运费，需要提示选择物流方式
            let shippingCost = 0;
            // let details = orderPageData.list;
            // for (let j = 0; j < details.length; j++) {
            let itemShippingCost = parseFloat(data[i].shipping_cost);
            if (itemShippingCost > 0) {
              shippingCost += itemShippingCost;
            } else {
              handleOrderShippingTips(true, data[i].dsm_order_number);
              return;
            }
            // }

            if (shippingCost <= 0) {
              isPass = false;
              noFreeShippingOrderName.push(data[i].dsm_order_number);
            }
            // 统计订单的运费
            totalShippingCost += shippingCost;
        }
      }
    }
    totalPrice += totalShippingCost
    setPaymentData((prevValue) => ({
      ...prevValue,
      isBatchToPay: true,
      user_cpf:listData.user_cpf,
      is_br:listData.is_br,
      batchPayOrderIds: ids,
    }));
    // 数据检测
    if (!isPass) {
      handleOrderShippingTips(true, noFreeShippingOrderName.join(","));
      return;
    }
    // 判断选择的订单地址异常情况
    if (!allAddressTrue) {
      handleAddressFailedTips(true, ids, orderAddressFailedNames.join(","));
      return;
    }

    if (ids.length > 0) {
      setPaymentData((prevValue) => ({
        ...prevValue,
        isBatchToPay: true,
        user_cpf:listData.user_cpf,
        is_br:listData.is_br,
        batchPayOrderIds: ids,
      }));
      let flag = false;
      for (let i = 0; i < data.length; i++) {
        if (ids.includes(data[i].dsm_record)) {
          if (
            data[i].shopify_financial_status === "refunded" ||
            data[i].shopify_financial_status === "partially_refunded"
          ) {
            flag = true;
          }
        }
      }
      if (flag) {
        setPaymentData((prevValue) => ({
          ...prevValue,
          isBatchToPay: true,
          batchPayOrderIds: ids,
        }));
        // setShopifyOrderRefundModalData((prevValue) => ({
        //   ...prevValue,
        //   shopifyOrderRefundModal: true,
        //   shopifyRefundOrderData: {
        //     name,
        //     PaymentType,
        //     totalPrice,
        //     totalShippingCost,
        //   },
        // }));
      } else {
        if (notSourcing) {
          setPaymentData((prevValue) => ({
            ...prevValue,
            isNotSourcing: true,
            totalPrice,
            totalShippingCost,
          }));
        } else {
          setPaymentData((prevValue) => ({
            ...prevValue,
            isShowBulkPaymentModal: true,
            totalPrice,
            totalShippingCost,
          }));
        }
       
      }
    } else {
      toastFun("No payable orders");
    }
    // setPaymentData({
    //   isShowBulkPaymentModal: true,
    //   user_cpf:listData.user_cpf,
    //   is_br:listData.is_br,
    //   batchPayOrderIds:result
    // });
  }
  const handleWalletActive = async (PaymentType) => {
      // 谷歌分析函数
      // this.handleTrackGoogleManager('Dropshipman pay order', {
      //   domain: utils.getStore('S_SHOP_DOMAIN') || window.S_SHOP_DOMAIN,
      //   value: this.state.totalPriceWallet,
      //   currency: 'USD',
      // })
  
      //判断钱包的钱是否够用
      if (
        listData?.wallet_money <
        paymentData.totalPriceWallet - paymentData.toPayCouponMoney
      ) {
        toastFun("Insufficient balance");
      } else {
        setPaymentData((prevValue) => ({
          ...prevValue,
          handleWalletActiveLoading: true,
        }));
        // this.setState({
        //   handleWalletActiveLoading: true,
        // })
        let ids = paymentData.batchPayOrderIds;
        // if (paymentData.isBatchToPay) {
        //   // 批量
        //   ids = paymentData.batchPayOrderIds;
        // } else {
        //   ids = paymentData.toPayOrderId;
        // }
  
        let params = {
          ids,
          b: 0,
          coupon_id: paymentData.toPayCouponId,
          is_point:paymentData.isPoints ? 1 : 0
        };
  
        const response = await reqPostOrderNewPaymentWallet(params);
        setPaymentData((prevValue) => ({
          ...prevValue,
          toWalletActive: false,
          toPayCouponId: 0,
          isPoints:false,
          toPayCouponMoney: 0,
        }));
  
        if (response.code === "200") {
          setPaymentData((prevValue) => ({
            ...prevValue,
            handleWalletActiveLoading: false,
          }));
          toastFun('Payment processing');
          // this.getDropshipmanOrderList()
          getPageData();
  
          // 启动定时器查询支付状态
          if (response.data) {
            setPaymentData((prevValue) => ({
              ...prevValue,
              payLogId: response.data.pay_id,
            }));
            var importTimer = setInterval(() => {
              GetPaymentProcess(response.data.pay_id).then(function (response) {
                if (response === 200) {
                  clearInterval(importTimer);
                }
              });
            }, 3000);
          }
        } else {
          toastFun(response.msg);
          setPaymentData((prevValue) => ({
            ...prevValue,
            handleWalletActiveLoading: false,
          }));
        }
        // 创建PayPal订单有误，关闭弹窗
        handlePayForOrderModal(0, 0, "", 0, false, PaymentType);
      }
    };
     // 查询支付的状态
      const GetPaymentProcess = async (id) => {
        const params = { id };
        const response = await reqGetOrderNewPaymentProcess(params);
        if (response.code === "200") {
          let getData = response.data;
          setPaymentData((prevValue) => ({
            ...prevValue,
            operationNumber: getData.job === 0 ? getData.total : 0,
            currentExecutionsNumber: getData.job === 0 ? getData.success : 0,
          }));
    
          if (getData.job === 1) {
            // 结束
            setTimeout(() => {
              // 刷新列表
              getPageData()
            }, 1000);
    
            return 200;
          }
          return 201;
        } else {
          setPaymentData((prevValue) => ({
            ...prevValue,
            payLogId: 0,
            operationNumber: 0,
            currentExecutionsNumber: 0,
          }));
    
          return 200;
        }
      };
  // [PayPal] Checkout 弹窗 PaymentType 支付类型 1:PayPal 2:钱包
  const handlePayForOrderModal = (
    recordKey,
    id,
    name,
    type,
    bool,
    PaymentType,
    totalPrice = 0,
    shippingCosts = 0,
    CouponId = 0,
    CouponMoney = 0,
    isPoints
  ) => {
    // setShopifyOrderRefundModalData((prevValue) => ({
    //   ...prevValue,
    //   shopifyOrderRefundModal: false,
    // }));
    setPaymentData((prevValue) => ({
      ...prevValue,
      handleWalletActiveLoading: false,
      toCheckoutLoading: false,
    }));

    switch (PaymentType) {
      case 1:
        setPaymentData((prevValue) => ({
          ...prevValue,
          toPayOrderId: id,
          toPayOrderName: name,
          toPayOrderType: type,
          batchPayOrderIds: id,
          toPayActive: bool,
          createPayPalOrderId: 0,
          toPayCouponId: CouponId,
          isPoints,
          toPayCouponMoney: CouponMoney,
        }));
        if (bool) {
          handleCheckoutOrder(PaymentType, {
            isBatchToPay:paymentData.isBatchToPay,
            batchPayOrderIds: id,
            toPayOrderId: id,
            toPayCouponId: CouponId,
            isPoints
          });
        } else {
          // 如果是批量下单
          if (paymentData.isBatchToPay) {
            setPaymentData((prevValue) => ({
              ...prevValue,
              isBatchToPay: false,
              batchPayOrderIds: [],
            }));
          }
        }
        break;
      case 2:
        setPaymentData((prevValue) => ({
          ...prevValue,
          toPayOrderId: id,
          toPayOrderName: name,
          toPayOrderType: type,
          toWalletActive: bool, //打开钱包提示弹窗
          totalPriceWallet: parseFloat(Number(totalPrice).toFixed(2)), //钱包支付订单金额
          createPayPalOrderId: 0,
          toPayCouponId: CouponId,
          isPoints,
          toPayCouponMoney: CouponMoney,
        }));
        if (bool) {
        } else {
          // 如果是批量下单
          if (paymentData.isBatchToPay) {
            setPaymentData((prevValue) => ({
              ...prevValue,
              isBatchToPay: false,
              batchPayOrderIds: [],
            }));
          }
        }
        break;
      case 3:
        break;
      default:
        break;
    }
  };

  // checkout order
    const handleCheckoutOrder = async (PaymentType, data) => {
      let ids = data.batchPayOrderIds;
      // if (data.isBatchToPay) {
      //   // 批量
      //   ids = data.batchPayOrderIds;
      // } else {
      //   ids = data.toPayOrderId;
      // }
      setPaymentData((prevValue) => ({
        ...prevValue,
        toCheckoutLoading: true,
      }));
      let params = {
        ids,
        // b: data.isBatchToPay ? 1 : 0,
        coupon_id: data.toPayCouponId,
        is_point:data.isPoints ? 1 : 0
      };
  
      const response = await reqGetOrderNewPaypalCheckout(params);
      setPaymentData((prevValue) => ({
        ...prevValue,
        toCheckoutLoading: false,
      }));
      if (response.code === "200") {
        // toggleToast(response.msg, false);
  
        setPaymentData((prevValue) => ({
          ...prevValue,
          createPayPalOrderId: response.data.id,
        }));
      } else {
        toastFun('Fail to activate');
        handlePayForOrderModal(0, 0, "", 0, false, PaymentType);
      }
    };
// 订单地址异常状态转换为待支付操作
  // 继续付款
  const handleAddressFailedOrderToUnpaid = () => {
    let data = listData?.list;

    let ids = [];
    let name = [];

    //金额
    var totalPrice = 0;
    let totalShippingCost = 0;
    // let itemsCount = 0;
    for (let i = 0; i < data.length; i++) {
      if (paymentData.batchPayOrderIds.includes(data[i].dsm_record)) {
        if (
          data[i].dsm_payment_status === "Unpaid" ||
          data[i].dsm_payment_status === "Partially paid"
        ) {
          ids.push(data[i].dsm_record);
          name.push(data[i].dsm_order_number);
          totalPrice +=
            Number(data[i].product_cost) + parseFloat(data[i].ioss_vat);

          // (shopify订单 type=1 \ 自定义订单 type=4) 不是包邮，且没有运费，需要提示选择物流方式
            let shippingCost = 0;
            let itemShippingCost = parseFloat(data[i].shipping_cost);
            if (itemShippingCost > 0) {
              shippingCost += itemShippingCost;
            }
            // 统计订单的运费
            totalShippingCost += shippingCost;
        }
      }
    }
    totalPrice += totalShippingCost;
    
    if (ids.length > 0) {
      setPaymentData((prevValue) => ({
        ...prevValue,
        isBatchToPay: true,
        addressFailedModal: false,
        batchPayOrderIds: ids,
        isShowBulkPaymentModal: true,
        totalPrice,
        totalShippingCost,
      }));
    }
  };

    // [单个/批量] 订单提示地址异常无法付款
  const handleAddressFailedTips = (bool, ids = [], orderName = "") => {
    if (bool && ids.length === 0) {
      // 处理批量
      let data = listData?.list;
      let name = [];
      for (let i = 0; i < data.length; i++) {
        if (paymentData.batchPayOrderIds.includes(data[i].dsm_record) && data[i].address_failed === 1) {
          ids.push(data[i].dsm_record);
          name.push(data[i].dsm_order_number);
        }
      }
      orderName = name.length > 0 ? name.join(",") : "";
    }
    setPaymentData((prevValue) => ({
      ...prevValue,
      addressFailedModal: bool,
      addressFailedOrder: orderName,
      setOrderStatusIds: ids,
    }));
  };
  // 订单提示选择物流方式
  const handleOrderShippingTips = (bool, orderName = "") => {
    setPaymentData((prevValue) => ({
      ...prevValue,
      noFreeShippingTipsActive: bool,
      noFreeShippingOrder: orderName,
    }));
  };

   
  const [dlocalTip,setDlocalTip] = useState(false);
   const [payoneerConnectOpen, setPayoneerConnectOpen] = useState(false);//payoneer 连接弹窗
   const [payoneerBalances,setPayoneerBalances] = useState({
     data:{},
     open:false,
     ids:[],
     coupon_id:0,
     isPoints:false
   })
    // 未授权弹窗 payoneer
     const callPayoneerConnectClosed = () => {
       setPayoneerConnectOpen(false);
     };
    
     const [payoneerConfirm,setPayoneerConfirm] = useState({
       data:{},
       open:false
     })
       // 获取确认支付数据
     const  handlePayoneerConfirm = (data)=>{
       setPayoneerConfirm((prevValue)=>({
         ...prevValue,
         data,
         open:true
       }))
     }
     //关闭确认支付弹窗
     const handlePayoneerConfirmClose = ()=>{
       getPageData();
     }
   
     const [payoneerAgainOpen,setPayoneerAgainOpen] = useState(false)//
     // 刷新数据
    const callPayoneerAgainClosed = ()=>{
      getPageData();
       setPayoneerAgainOpen(false)
     }
      // 展开所有子项
       const handleShowItem = (open)=>{
         let list = listData?.list;
         setCollapsibleItem(open)
         if (open) {
           forEach(list, (item) => {
             item.show = 1;
           });
           setListData((prev) => ({
             ...prev,
             list,
           }));
         }else {
           forEach(list, (item) => {
             item.show = 0;
           });
           setListData((prev) => ({
             ...prev,
             list,
           }));
         }
       }
    const resourceName = {
      singular: "order",
      plural: "orders",
    };
    const headingData = [
      { id: "1", title: <Box style={{cursor:'pointer'}} onClick={()=>{
            handleShowItem(!collapsibleItem)
          }}>
            <InlineStack blockAlign="center">
            <span>Order</span>
            <Tooltip content="Expand Order"><span>
            {collapsibleItem ? <Icon
              source={ChevronUpIcon}
              tone="base"
            />:<Icon
            source={ChevronDownIcon}
            tone="base"
          />}
            </span></Tooltip>
          </InlineStack>
          
          </Box> },
      { id: "2", title: <span>Status</span> },
      { id: "3", title: <span>Date</span> },
      { id: "4", title: <span>Customer</span> },
      { id: "6", title: <span>Shiping method</span> },
      { id: "7", title: <span>Item</span> },
      { id: "8", title: <span>Total</span> },
      { id: "9", title: <span>Action</span> },
    ];
    const promotedBulkActions = selected !== 4 ? [
      {
        content: 'Bulk payment',
        onAction: () => {
          handleBulkPayment(selectedResources)
        },
      },
      {
        content: 'Archive orders',
        onAction: () => {
          // 创建 Set 用于快速查找
          const idSet = new Set(selectedResources);
          const split_order_list = listData?.list
            .filter((item) => idSet.has(item.id))
            .filter((item) => item.split_order !== 0);
          // 过滤出 id 在 Set 中的对象
          const result = listData?.list
            .filter((item) => idSet.has(item.id))
            .map((item) => item.dsm_record);
          const shopifyIds = [];
          setArchiveOrderData((prev) => ({
            ...prev,
            open: true,
            archive: true,
            ids: result,
            sid: shopifyIds,
            split_order_list
          }));
        },
      },
    ] : [
      {
        content: "Unarchive orders",
        onAction: () => {
          // 创建 Set 用于快速查找
          const idSet = new Set(selectedResources);
          // 过滤出 id 在 Set 中的对象
          const split_order_list = listData?.list
          .filter((item) => idSet.has(item.id))
          .filter((item) => item.split_order !== 0);
          const result = listData?.list
            .filter((item) => idSet.has(item.id))
            .map((item) => item.dsm_record);
          const shopifyIds = [];
          setArchiveOrderData((prev) => ({
            ...prev,
            open: true,
            archive: false,
            ids: result,
            sid: shopifyIds,
            split_order_list
          }));
        },
      },
    ]
    // 进度器
    // 1. 默认展示4个进度器，当存在未source完成时有5个进度器;
    // 2. 每个进度器有多种状态，但仅展示当前进度的状态
    // 3. 4个进度器中，默认仅展示一个核心状态，其他进度器为灰色且无内容，只有鼠标移上指定的进度器才展示内容
    // 4. 鼠标移上进度器会有动画过渡效果，比如从左往右移动动效就是从左往右。
    const ProgressGroup = ({data}) => {
      const [currentIndexProgress,setCurrentIndexProgress] = useState(data.currentShow)
      // 默认状态内容
      let shopifyPaid = [
        {
          bg: 'rgba(146, 254, 194, 1)',
          color: 'rgba(12, 81, 50, 1)',
          content: 'Paid',
          tips: 'Shopify payment status',
          icon:'/shop-icon-shopify.png'
        },
        {
          bg: 'rgba(255, 239, 157, 1)',
          color: 'rgba(79, 71, 0, 1)',
          content: 'Unpaid',
          tips: 'Shopify payment status',
          icon:'/shop-icon-shopify.png'
        },
      ];
      let sourcingStats = [
        {
          bg: 'rgba(255, 239, 157, 1)',
          color: 'rgba(79, 71, 0, 1)',
          content: 'Awaiting sourcing',
          tips: 'shopify',
        },
        {
          bg: 'rgba(202, 230, 255, 1)',
          color: 'rgba(0, 82, 124, 1)',
          content: 'Pending sourcing',
          tips: 'shopify',
        },
        {
          bg: 'rgba(254, 218, 217, 1)',
          color: 'rgba(142, 31, 11, 1)',
          content: 'Not sourcing',
          tips: 'shopify',
        },
      ];
      
      let dsmPaid = [
        {
          bg: 'rgba(146, 254, 194, 1)',
          color: 'rgba(12, 81, 50, 1)',
          content: 'Paid',
          tips: 'Dropshipman payment status',
           icon:'/dropshipman-logo.png'
        },
        {
          bg: 'rgba(255, 239, 157, 1)',
          color: 'rgba(79, 71, 0, 1)',
          content: 'Unpaid',
          tips: 'Dropshipman payment status',
           icon:'/dropshipman-logo.png'
        },
        {
          bg: 'rgba(224, 240, 255, 1)',
          color: 'rgba(0, 82, 124, 1)',
          content: 'Pending',
          tips: 'Dropshipman payment status',
           icon:'/dropshipman-logo.png'
        },
        {
          bg: 'rgba(254, 218, 217, 1)',
          color: 'rgba(142, 31, 11, 1)',
          content: 'Refunded',
          tips: 'Dropshipman payment status',
           icon:'/dropshipman-logo.png'
        },
        {
          bg: 'rgba(255, 214, 164, 1)',
          color: 'rgba(94, 66, 0, 1)',
          content: 'Partially Refund',
          tips: 'Dropshipman payment status',
           icon:'/dropshipman-logo.png'
        },
       
      ];
      
      let dsmFulfilled = [
        {
          bg: 'rgba(146, 254, 194, 1)',
          color: 'rgba(12, 81, 50, 1)',
          content: 'Fulfilled',
          tips: 'Dropshipman fulfillment status',
          icon:'/dropshipman-logo.png'
        },
        {
          bg: 'rgba(243, 243, 243, 1)',
          color: 'rgba(97, 97, 97, 1)',
          content: 'Unfulfilled',
          tips: 'Dropshipman fulfillment status',
          icon:'/dropshipman-logo.png'
        },
        {
          bg: "rgba(202, 230, 255, 1)",
          color: "rgba(0, 82, 124, 1)",
          content: 'In Processing',
          tips: 'Dropshipman fulfillment status',
          icon:'/dropshipman-logo.png'
        },
      ];
     
    
      // 根据 data 动态生成进度状态
      let currentProgress = [];
      if (data.shopify_financial_status === 'Paid') {
        currentProgress.push(shopifyPaid[0]);
      } else if (data.shopify_financial_status === 'Unpaid') {
        currentProgress.push(shopifyPaid[1]);
      }else if (data?.shopify_financial_status && data?.shopify_financial_status !== '') {
        currentProgress.push({
          bg: 'rgb(243, 243, 243)',
          color: 'rgb(97, 97, 97)',
          content: data.shopify_financial_status,
          tips: 'Dropshipman payment status',
          icon:'/shop-icon-shopify.png'
        });
      }
    
      // 增加其他状态的处理逻辑
      if (data.sourcing_status) {
        const sourcingStatus = sourcingStats.find((status) => status.content === data.sourcing_status);
        if (sourcingStatus) {
          currentProgress.push(sourcingStatus);
        }
      }
    
      
    
      if (data.dsm_payment_status) {
        let dsmPaidStatus = dsmPaid.find((status) => status.content === data.dsm_payment_status);
        if (dsmPaidStatus) {
          if (data.dsm_payment_status === 'Partially Refund') {
            dsmPaidStatus.content = 'Partially Refunded';
          }
          currentProgress.push(dsmPaidStatus);
        }else if (data.dsm_payment_status !== ''){
          currentProgress.push({
            bg: 'rgb(243, 243, 243)',
            color: 'rgb(97, 97, 97)',
            content: data.dsm_payment_status,
            tips: 'Dropshipman payment status',
            icon:'/dropshipman-logo.png'
          });
        }
      }
    
      if (data.dsm_shipment_status) {
        const dsmFulfilledStatus = dsmFulfilled.find((status) => status.content === data.dsm_shipment_status);
        if (dsmFulfilledStatus) {
          currentProgress.push(dsmFulfilledStatus);
        }else if (data.dsm_shipment_status !== ''){
          currentProgress.push({
            bg: 'rgb(243, 243, 243)',
            color: 'rgb(97, 97, 97)',
            content: data.dsm_shipment_status,
            tips: 'Dropshipman fulfillment status',
            icon:'/dropshipman-logo.png'
          });
        }
      }
      
      let currentIndex = currentIndexProgress  ? currentIndexProgress : data?.currentShow
      // 渲染进度器
      return (
        <div className="progress-group" onMouseLeave={()=>{ setCurrentIndexProgress(data?.currentShow)}}>
          {currentProgress.map((item, index) => (
            <div
              key={index}
              className={currentIndex === (index+1) ? "progress-item" : "progress-item progress-item-hide"}
              style={{
                backgroundColor: currentIndex === (index+1) ? item.bg : '#ddd',
                color: currentIndex === (index+1) ? item.color : 'transparent',
                width: currentIndex === (index+1) ? `${Math.max(item?.content?.length * 10, 60)}px` : '0',
                transition: 'all 0.3s ease',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                fontWeight:550,
              }}
              onMouseEnter={() => {
                // 鼠标移上时，更新当前显示的进度
                setCurrentIndexProgress(index + 1);
              }}
            >
               <Tooltip width="200" content={
                <Box>
                  <InlineStack gap={100} blockAlign="center">
                  <Thumbnail
                    source={item.icon}
                    size="extraSmall"
                    alt={item.tips}
                  />
                  <Box>{item.tips}</Box>
                  </InlineStack>
                </Box>
               }>
              <span className="progress_content_span">{item.content}</span>
              </Tooltip>
            </div>
          ))}
        </div>
      );
    };
  
  // 处理点击事件，切换展开状态
  const handleClick = (item,ind) => {
    if (item.show) {
      let newOrders = listData?.list.map((item, index) => {
        if (index === ind) {
          return {
            ...item,
            show: 0,
          };
        }
        return item;
      });
      setListData({
        ...listData,
        list: newOrders,
      });
    }else {
      let newOrders = listData?.list.map((item, index) => {
        if (index === ind) {
          return {
            ...item,
            show: 1,
          };
        }else {
          return {
            ...item,
            show: 0,
          };
        }
      });
      setListData({
        ...listData,
        list: newOrders,
      });
    }
  };
  const ChildrenItem = ({data})=>{
    let detail = data?.items || [];
    let node = '';
    if (detail.length > 0) {
      node = detail.map((item, index) => (<IndexTable.Row
        key={index}
        rowType="child"
        selectable={true}
        disabled={true}
        onClick={()=>{}}
      >
        <td className="children_content_item" colSpan={9}>
         <Box className='children_content_item_box' >
          <InlineStack align="space-between" blockAlign="center">
            <Box className='children_content_item_left'>
            <InlineStack blockAlign="center" gap={200}>
              <Box style={{opacity:0}}>
              {/* <Checkbox
                checked={item.checked}
                onChange={(value)=>{
                 
                }}
              /> */}
              </Box>
              <Box>
                 <Thumbnail
                    source={item.image_url || NoteIcon}
                    size="small"
                    alt="Black choker necklace"
                  />
              </Box>
              <Box>
                <Box className="children_content_item_left_title" title={item.title}>{item.title}</Box>
                <Box>
                  <InlineStack align="flex-start"  blockAlign="center" gap={400}>
                  <Box>
                    {item.dsm_refund_count > 0 ? (
                      <Tooltip
                        dismissOnMouseOut
                        content={
                          item.quantity > item.dsm_refund_count
                            ? `Partially Refund : ${item.dsm_refund_count}`
                            : "Refund"
                        }
                      >
                        <Badge tone={"critical"}>
                          {item.quantity > item.dsm_refund_count
                            ? `Partially Refund : ${item.dsm_refund_count}`
                            : "Refund"}
                        </Badge>
                      </Tooltip>
                    ) : ''}
                  </Box>
                    <Box>SKU: {item.sku}</Box>
                    {/* <Box>Brown / 43</Box> */}
                    <Box>Price: <SymbolTake price={parseFloat(item.price).toFixed(2)} /></Box>
                  </InlineStack>
                </Box>
              </Box>
              </InlineStack>
            </Box>
            <Box className='children_content_item_right'>
              <InlineStack blockAlign="center" gap={200}>
              <Box>
                <Box>Cost: <SymbolTake price={parseFloat(item.price).toFixed(2)} /> x {item.quantity}</Box>
                <Box className="children_content_item_right_total">Total: <SymbolTake price={parseFloat(item.total).toFixed(2)} /></Box>
              </Box>
              <Box>
              </Box>
              </InlineStack>
            </Box>
          </InlineStack>
         </Box>
        </td>
      </IndexTable.Row>
  ))
    }
    
   return data.show ? node : '';
  }
  // 总价转换
  const [isShow,setIsShow] = useState('');
  const TotalFun = ({data})=>{
    let total = (parseFloat(data.product_cost) +
        parseFloat(data.shipping_cost) +
        parseFloat(data.ioss_vat) -
        parseFloat(data.coupon_money));
    total = Math.max(total, 0).toFixed(2)
    let node = <Box>
      <Popover
        active={isShow === data.id}
        activator={<span className="order_total_text" onMouseEnter={()=>{
          setIsShow(data.id);
        }}>${total}</span>}
        autofocusTarget="first-node"
        onClose={()=>{setIsShow('')}}
      >
       <Box style={{width:'200px',padding:'10px'}}>
       <Box>Product Cost:  <SymbolTake price={parseFloat(data.product_cost).toFixed(2)} /></Box> 
       <Box>Discounted: {data.coupon_money > 0 ? <SymbolTake price={parseFloat(data.coupon_money).toFixed(2)} /> : "$0.00"}</Box> 
       <Box>Shipping Cost: <SymbolTake price={parseFloat(data.shipping_cost).toFixed(2)} /></Box> 
       <Box>VAT: <SymbolTake price={parseFloat(data.ioss_vat).toFixed(2)} /></Box> 
       <Box>Total: <SymbolTake price={total} /></Box> 
       </Box>
       </Popover>
    </Box>
    
    return node;
  }
  const [btnShow,setBtnShow] = useState('');// 按钮组展示
  
  const buttonGroup = (data)=>{
    let node = '';
    if (data.dsm_payment_status === 'Unpaid') {
      node = <Button onClick={(e)=>{
        e.stopPropagation();
        handleBulkPayment([data.id])
      }}>Payment</Button>;
    }
    if (data.dsm_payment_status === "Paid" || data.dsm_payment_status === "Partially Refund") {
      node = <InlineStack gap={200}>
        <Button variant="plain" onClick={(e)=>{
          e.stopPropagation();
          setTrackingData((prev)=>({
            ...prev,
            id:data.dsm_record,
            open:true,
            data:{
              ...data,
              dsm_order_name:data.dsm_order_number
            }
          }))
        }}>Tracking</Button>
        {data?.is_back !==1 && <Button variant="tertiary" onClick={(e)=>{
        e.stopPropagation();
        if (binding_sale === 1) {
          setOrderRefundData((prev)=>({
            ...prev,
            id:data.dsm_record,
            open:true,
            data:{
              ...data,
              dsm_order_number:data.dsm_order_number
            }
          }))
        }else {
          let sendMsg =
          `Hi, I would like to request a refund for order ${data.dsm_order_number}`;
          try {
            // 填充信息并激活对话弹窗
            // window.Intercom('showNewMessage', sendMsg)
            window.Willdesk.show();
            window.Willdesk.chat(sendMsg);
          } catch (error) {
            console.info(error);
          }
        }
       
          
        }}>Refund</Button>}
      </InlineStack>
    }
    if ((data.dsm_shipment_status === "Fulfilled" || data.dsm_shipment_status === "Delivered")) {
      node = <Popover
      active={btnShow === data.id}
      activator={<Button variant="tertiary" icon={MenuHorizontalIcon} onClick={(e)=>{
        e.stopPropagation();
        setBtnShow(btnShow === data.id ? '' : data.id);
      }}></Button>}
      autofocusTarget="first-node"
      onClose={()=>{setBtnShow('')}}
    >
      <ActionList
        actionRole="menuitem"
        items={[
          {content: 'Tracking',onAction:()=>{
            setTrackingData((prev)=>({
              ...prev,
              id:data.dsm_record,
              open:true,
              data:{
                ...data,
                dsm_order_name:data.dsm_order_number
              }
            }))
          }}, 
          data?.is_back !==1 && {content: 'Refund',onAction:()=>{
            if (binding_sale === 1) {
              setOrderRefundData((prev)=>({
                ...prev,
                id:data.dsm_record,
                open:true,
                data:{
                  ...data,
                  dsm_order_number:data.dsm_order_number
                }
              }))
            }else {
              let sendMsg =
              `Hi, I would like to request a refund for order ${data.dsm_order_number}`;
              try {
                // 填充信息并激活对话弹窗
                // window.Intercom('showNewMessage', sendMsg)
                window.Willdesk.show();
                window.Willdesk.chat(sendMsg);
              } catch (error) {
                console.info(error);
              }
            }
            
          }}, 
          {content: 'Invoice',
            onAction:(e)=>{
            setInvoicesData((prev)=>({
              ...prev,
              id:data.dsm_record,
              open:true,
              data:data
            }))
          }}
        ]}
      />
    </Popover>
    }
    return node;
  }
  // 不包邮订单提示用户选择物流方式
  const noFreeShippingTipsModal = (
    <Modal
      open={paymentData.noFreeShippingTipsActive}
      title={"Shipping method not selected"}
      onClose={() => handleOrderShippingTips(false)}
      secondaryActions={[
        {
          content: "Got it",
          onAction: () => handleOrderShippingTips(false),
        },
      ]}
    >
      <Modal.Section>
         
          <p>
            {"Please choose a shipping method for order"}
            <b>{paymentData.noFreeShippingOrder}</b>
            {"."}
          </p>
         
      </Modal.Section>
    </Modal>
  );
    const rowMarkup = listData?.list?.map((item, ind) => {
      // 1. 制作一个手风琴向下展开的盒子
      // 2. 通过控制是否展开的状态，控制是否显示下面的内容
      // 3. 向下展开时有动画效果，收起时也有动画效果
  
      return (
        <Fragment key={ind}>
          <IndexTable.Row
            id={item.id}
            key={ind}
            selected={selectedResources.includes(item.id)}
            position={ind}
            // disabled={item.dsm_payment_status !== 'Unpaid'}
            onClick={()=>{
              if (btnShow !== '') {
                return;
              }
              handleClick(item,ind)
            }}
          >
            <IndexTable.Cell className="order_cell_01">
              <Box  onMouseLeave={()=>{setIsShow('')}}>
                <Box>
                  <InlineStack gap={100} blockAlign="center">
                    <Box className="dsm_order_number_title">{item.dsm_order_number}</Box>
                  </InlineStack>
                </Box>
               
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_02">
              <Box className="progress_group_box"  onMouseLeave={()=>{setIsShow('')}}>
                <ProgressGroup data={{...item,currentShow:item.process_state}}/>
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_03">
              <Box  onMouseLeave={()=>{setIsShow('')}}>
                <Box className='dsm_order_date_text'>{item.dsm_date}</Box>
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_04">
              <Box  onMouseLeave={()=>{setIsShow('')}}>
              <InlineStack gap={100} blockAlign="center">
              <div className="order_customer_info">
            <Button
             onClick={(e) => {
              e.stopPropagation();
             setAddressData({...item,open:true})
             }}
            variant="palin"
            size="micro"
            loading={false}
            >
          <Tooltip content={"Click to edit customer shipping address and information"}>
            <InlineStack  gap={100} blockAlign="center"  wrap={false}>
            <span>
            <Icon
                source={PersonIcon}
                tone="base"
            />
            </span>
            {item.address_failed ? <div
          >
            <img src="/order_fulfillment/failed_icon.png" alt="dropshipman" />
          </div> : <span className="order_icon_dwon">
                <Icon source={ChevronDownIcon} />
            </span>}
            
            </InlineStack>
        </Tooltip>
        </Button>
        </div>
              </InlineStack>
              </Box>
            </IndexTable.Cell>
           
            <IndexTable.Cell className="order_cell_06">
              <Box  onMouseLeave={()=>{setIsShow('')}}>
                <Box>
                <Button
                  onClick={(e)=>{
                    e.stopPropagation();
                    
                    setShippingMethodsData({...item,open:true})
                  }}
                  variant="palin"
                  size="micro"
                  loading={false}
                >
                  {/* <Tooltip content="Click to Choose Shipping Methods"> */}
                  <InlineStack  wrap={false}>
                 <span className="order_cost_text">Cost: <SymbolTake price={parseFloat(item.shipping_cost).toFixed(2)} /></span>
                  <span className="order_icon_dwon">
                    <Icon source={ChevronDownIcon} />
                  </span>
                  </InlineStack>
                  {/* </Tooltip> */}
                  
                </Button>
                </Box>
                <Box>{item.dsm_shipping}</Box>
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_07">
              <Box  onMouseLeave={()=>{setIsShow('')}}>
                <Box className="order_item_count_text">{item.item_count} Total</Box>
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_08">
              <Box  onMouseLeave={()=>{setIsShow('')}}>
                <TotalFun data={item}/>
                <Box className='pay_line'>
                {(item.dsm_payment_status !== 'Unpaid' && item.coupon_money !== 0) && <SymbolTake price={(parseFloat(item.product_cost) +
                  parseFloat(item.shipping_cost) +
                  parseFloat(item.ioss_vat)).toFixed(2)}/>}
                </Box>
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_09">
              <Box  onMouseLeave={()=>{setIsShow('')}}>
              {buttonGroup(item)}
               
              </Box>
            </IndexTable.Cell>
          </IndexTable.Row>
          <ChildrenItem data={item} />
        </Fragment>
      );
    });
    // 订单地址异常支付提醒
      let addressFailedTips = (
        <Modal
          open={paymentData.addressFailedModal}
          onClose={() => handleAddressFailedTips(false)}
          title={"Incorrect customer information"}
          primaryAction={{
            content: "Cancel",
            onAction: () => handleAddressFailedTips(false),
          }}
          secondaryActions={[
            {
              content: "Continue to pay",
              onAction: () => handleAddressFailedOrderToUnpaid(),
              loading: paymentData.addressFailedLoading,
            },
          ]}
        >
          <Modal.Section>
            <p>
             {"The customer information for order"}{" "}
              <span style={{ fontWeight: "500" }}>
                {paymentData.addressFailedOrder}
              </span>{" "}
             {"is incorrect. This may affect the normal delivery of the order and we suggest correcting the information before paying."}
            </p>
          </Modal.Section>
        </Modal>
      );
   // 支付进度显示
    let paymentTips = <div></div>;
    if (paymentData.operationNumber !== 0) {
      paymentTips = (
        <div style={{ marginBottom: "1rem" }}>
          <Banner
            title={
              paymentData.currentExecutionsNumber +
              "/" +
              paymentData.operationNumber +
              " orders are being paid."
            }
            tone="info"
            // onDismiss={() => {}}
          ></Banner>
        </div>
      );
    }
// 定义参数有效性检查工具函数
const hasValidParams = (params) => {
  if (!params) return false;

  // 需要验证的非空字符串参数
  const stringParams = [
    "order_number",
    "start_time",
    "end_time",
  ];

  // 需要验证的非空数组参数
  const arrayParams = [
    "payment_status",
  ];

  // 检查字符串参数
  const hasValidString = stringParams.some(
    (key) => params[key] !== undefined && params[key] !== ""
  );

  // 检查数组参数
  const hasValidArray = arrayParams.some((key) => params[key]?.length > 0);

  return hasValidString || hasValidArray;
};
    const emptyStateMarkup =
    Object.values(listData).length > 0 ? (
      <Box>
        {listData?.list?.length === 0 && (
          <Box>
            {hasValidParams(requestParams) ? (
              <InitNotPageContent data={{q:requestParams.order_number}} />
            ) : (
              <InitPageContent
                selected={selected}
                setNoviceModal={()=>{}}
              />
            )}
          </Box>
        )}
      </Box>
    ) : (
      <CommonTableSkeletonItem />
    );
    return (
      <div className="order_table_box product_table_box" onMouseLeave={()=>{
        setIsShow('')
      }}>
        {paymentTips}
        <IndexTable
          resourceName={resourceName}
          itemCount={listData?.list?.length
            ? listData?.list?.length
            : 0}
          selectedItemsCount={
            allResourcesSelected ? "All" : selectedResources.length
          }
          onSelectionChange={handleSelectionChange}
          headings={headingData}
          promotedBulkActions={promotedBulkActions}
          emptyState={emptyStateMarkup}
          pagination={{
            label: listData?.list?.length > 0 ? pageMsg() : "",
            hasPrevious: hasPrevious,
            onPrevious: () => {
              handlePrev();
            },
            hasNext: hasNext,
            onNext: () => {
              handleNext();
            },
          }}
        >
          {rowMarkup}
        </IndexTable>
         {/* 礼品包装数据 */}
          {/* 地址选择 */}
          {addressData.open && <CustomerInformationModal
          setAddressData={setAddressData} 
          open={addressData.open}
          id={addressData.dsm_record}
          sid={0}
          type={4}
          toastFun={toastFun}
          countryCode={addressData.shipping_country}
          paymentStatus={'Paid'}
          addressStatus={addressData.address_failed}
          requestParams={requestParams}
          getPageData={getPageData}
          setSearchLoading={setSearchLoading}
          />}
         {/* 物流方式选择 */}
         <ShippingMethodsModal 
          orderId={shippingMethodsData.dsm_record}
          requestParams={requestParams}
          getPageData={getPageData}
          open={shippingMethodsData.open}
          orderPayStatus={shippingMethodsData.dsm_payment_status}
          setIsShowShippingMethodsModal={() =>
          setShippingMethodsData({open:false})
          } />

          {/* 物流轨迹 */}
          {trackingData.open && <OrderTrackingModal 
            trackingData={trackingData} 
            setTrackingData={setTrackingData}
            manualOrder={true}
            toastFun={toastFun}
            />}
           {/* 退款详情弹窗 销售绑定信息 */}
        <RefundTipsModal
          open={orderRefundData.open}
          datas={orderRefundData.data}
          setIsShowRefundTipsModal={() => setOrderRefundData((prev)=>({
            ...prev,
            open:false
          }))}
        />
        {/* 归档/解档 */}
      <ArchiveOrderModal
        archiveOrderData={archiveOrderData}
        getPageData={getPageData}
        toastFun={toastFun}
        setArchiveOrderData={setArchiveOrderData}
      />
        {/* 开票弹窗 */}
        <OrderInvoiceModal 
        toastFun={toastFun}
        data={invoicesData} 
        callColse={()=>{
          setInvoicesData((prev)=>({
            ...prev,
            open:false
          }))
        }}/>

        {/* 支付模块 */}
        {/* 批量支付弹窗 */}
        <BulkPaymentModal
              handlePayForOrderModal={handlePayForOrderModal}
              paymentData={paymentData}
              setDlocalTip={setDlocalTip}
              payoneerAuth={listData.payoneer_auth}//payoneer授权
              setPayoneerConnectOpen={setPayoneerConnectOpen}
              setPayoneerBalances={setPayoneerBalances}
              setIsShowBulkPaymentModal={() => {
                setPaymentData((prevValue) => ({
                  ...prevValue,
                  isShowBulkPaymentModal: false,
                }))
              }
              }
              walletMoney={listData.wallet_money}
            />
            <PayForOrderModal
              paymentData={paymentData}
              handlePayForOrderModal={handlePayForOrderModal}
              getPageData={getPageData} //获取页面数据
              orderPayment={true}
            />
            {/* 钱包支付 */}
            <WalletForOrderModal
              paymentData={paymentData}
              handleWalletActive={handleWalletActive}
              walletMoney={listData?.wallet_money}
              handlePayForOrderModal={handlePayForOrderModal}
            />

            {/* 物流提示 */}
            {noFreeShippingTipsModal}
            {/* 订单地址异常支付提醒 */}
            {addressFailedTips}

            {/* payoneer未授权 */}
              <PayoneerBalancesConnect 
              open={payoneerConnectOpen}
              callPayoneerConnectClosed={callPayoneerConnectClosed}
              />
                {/* 选择payoneer支付账户 */}
            <PayoneerBalancesOrderSelect 
              datas={payoneerBalances} 
              setPayoneerBalances={setPayoneerBalances}
              handlePayoneerConfirm={handlePayoneerConfirm}
              />
                {/* 确认付款 */}
                <PayoneerBalancesOrderConfirm
                handlePayoneerConfirmClose={handlePayoneerConfirmClose}
              data={payoneerConfirm.data}
              open={payoneerConfirm.open}
              setPayoneerAgainOpen={setPayoneerAgainOpen}
              setPayoneerConfirm={setPayoneerConfirm}
              />
              <PayoneerBalancesAgain 
              open={payoneerAgainOpen} 
              callPayoneerAgainClosed={callPayoneerAgainClosed}
              />

               {/* dlocal支付完成提示 */}
            <DlocalPayTipModal setDlocalTip={setDlocalTip} dlocalTip={dlocalTip}  getPageData={getPageData} />
      </div>
    );
  };
  
  export default OrderTable;
  